import { StaffApi } from 'helpers';

class PdfService {
  authToken: string;
  pdfService: StaffApi;

  public constructor(authToken: string) {
    this.authToken = authToken;
    this.pdfService = new StaffApi('pdf', authToken);
  }
}

export default PdfService;

export function preparePdfForEditing(
  authToken: string,
  pdf: Blob,
  signal?: AbortSignal
): Promise<Blob>;
export function preparePdfForEditing(
  authToken: string,
  pdf: Uint8Array,
  signal?: AbortSignal
): Promise<Uint8Array>;
export async function preparePdfForEditing(
  authToken: string,
  pdf: Blob | Uint8Array,
  signal?: AbortSignal
): Promise<Blob | Uint8Array> {
  const body = pdf instanceof Blob ? pdf : new Blob([pdf.slice().buffer]);
  const { data } = await new PdfService(authToken).pdfService.post(
    'PreparePdfForEditing',
    body,
    {},
    { 'Content-Type': 'application/pdf' },
    signal,
    { responseType: 'blob' }
  );

  const preparedPdf = data as Blob;
  return pdf instanceof Blob ? preparedPdf : new Uint8Array(await preparedPdf.arrayBuffer());
}
